// Centralized league data and helpers

// Basic league constants
export const TEAMS_PER_ROUND = 12;
export const TOTAL_PICKS = 204; // 17 rounds * 12 teams

// Canonical team order (base snake order)
// Note: This should reflect the official 1.01 → 1.12 draft order
export const TEAM_ORDER = [
  "AJ",
  "Chris",
  "Bobby",
  "Terry",
  "Derrick",
  "Gary",
  "Filter",
  "Manny",
  "Kenny",
  "Franco",
  "Todd",
  "Scheck",
];

// Single source of truth for all trades
// Picks can be formatted as "1.7" or "1.07"; helpers will normalize
export const TRADES = [
  { tradeId: 1, from: "Filter", to: "Gary", picks: ["1.7"], date: "August 1, 2025" },
  { tradeId: 1, from: "Gary", to: "Filter", picks: ["1.6"], date: "August 1, 2025" },
  { tradeId: 2, from: "Filter", to: "Scheck", picks: ["3.7", "4.6"], date: "August 1, 2025" },
  { tradeId: 2, from: "Scheck", to: "Filter", picks: ["2.1", "12.1"], date: "August 1, 2025" },
  { tradeId: 3, from: "Scheck", to: "Chris", picks: ["1.12", "13.12"], date: "August 1, 2025" },
  { tradeId: 3, from: "Chris", to: "Scheck", picks: ["3.2", "4.11"], date: "August 1, 2025" },
  { tradeId: 4, from: "Filter", to: "Scheck", picks: ["2.6", "5.7"], date: "August 1, 2025" },
  { tradeId: 4, from: "Scheck", to: "Filter", picks: ["3.2", "4.6"], date: "August 1, 2025" },
  { tradeId: 5, from: "Chris", to: "Manny", picks: ["2.11", "7.2"], date: "August 1, 2025" },
  { tradeId: 5, from: "Manny", to: "Chris", picks: ["3.8", "5.8"], date: "August 1, 2025" },
  { tradeId: 6, from: "Gary", to: "Bobby", picks: ["3.6", "6.7"], date: "August 1, 2025" },
  { tradeId: 6, from: "Bobby", to: "Gary", picks: ["2.10", "9.3"], date: "August 1, 2025" },
  { tradeId: 7, from: "Filter", to: "Chris", picks: ["2.1", "4.6"], date: "August 9, 2025" },
  { tradeId: 7, from: "Chris", to: "Filter", picks: ["1.2", "12.11"], date: "August 9, 2025" },
  { tradeId: 8, from: "Filter", to: "AJ", picks: ["1.2", "6.6"], date: "August 10, 2025" },
  { tradeId: 8, from: "AJ", to: "Filter", picks: ["1.1", "6.12"], date: "August 10, 2025" },
  { tradeId: 9, from: "Filter", to: "Kenny", picks: ["1.6", "10.6"], date: "August 10, 2025" },
  { tradeId: 9, from: "Kenny", to: "Filter", picks: ["2.4", "4.4"], date: "August 10, 2025" },
  { tradeId: 10, from: "Filter", to: "Terry", picks: ["1.1", "4.4"], date: "August 11, 2025" },
  { tradeId: 10, from: "Terry", to: "Filter", picks: ["1.4", "2.9"], date: "August 11, 2025" },
  { tradeId: 11, from: "Filter", to: "Terry", picks: ["3.2", "8.6"], date: "August 11, 2025" },
  { tradeId: 11, from: "Terry", to: "Filter", picks: ["4.9", "5.4"], date: "August 11, 2025" },
  { tradeId: 12, from: "Bobby", to: "Terry", picks: ["3.6", "8.10"], date: "August 12, 2025" },
  { tradeId: 12, from: "Terry", to: "Bobby", picks: ["4.6", "7.4"], date: "August 12, 2025" },
  { tradeId: 13, from: "Scheck", to: "Terry", picks: ["2.6", "4.11", "8.1"], date: "August 12, 2025" },
  { tradeId: 13, from: "Terry", to: "Scheck", picks: ["3.4", "3.6", "8.10"], date: "August 12, 2025" },
  { tradeId: 14, from: "Manny", to: "AJ", picks: ["7.2", "7.8"], date: "August 15, 2025" },
  { tradeId: 14, from: "AJ", to: "Manny", picks: ["6.6", "9.1"], date: "August 15, 2025" },
  { tradeId: 15, from: "Manny", to: "Terry", picks: ["6.5", "6.6"], date: "August 16, 2025" },
  { tradeId: 15, from: "Terry", to: "Manny", picks: ["4.11", "8.9"], date: "August 16, 2025" },
  { tradeId: 16, from: "Derrick", to: "Terry", picks: ["1.5", "6.8"], date: "August 16, 2025" },
  { tradeId: 16, from: "Terry", to: "Derrick", picks: ["1.1", "12.9"], date: "August 16, 2025" },
  { tradeId: 17, from: "AJ", to: "Filter", picks: ["8.12", "10.12", "11.1"], date: "August 17, 2025" },
  { tradeId: 17, from: "Filter", to: "AJ", picks: ["7.7", "11.7", "17.7"], date: "August 17, 2025" },
  { tradeId: 18, from: "Filter", to: "Terry", picks: ["2.4", "4.9"], date: "August 18, 2025" },
  { tradeId: 18, from: "Terry", to: "Filter", picks: ["1.5", "13.4"], date: "August 18, 2025" },
  { tradeId: 19, from: "Filter", to: "Terry", picks: ["2.9", "10.12", "12.1"], date: "August 20, 2025" },
  { tradeId: 19, from: "Terry", to: "Filter", picks: ["4.9", "6.6", "8.6"], date: "August 20, 2025" },
  { tradeId: 20, from: "Filter", to: "Terry", picks: ["4.9", "11.1"], date: "August 20, 2025" },
  { tradeId: 20, from: "Terry", to: "Filter", picks: ["6.8", "6.9"], date: "August 20, 2025" },
  { tradeId: 21, from: "Manny", to: "Bobby", picks: ["8.9", "9.1"], date: "August 21, 2025" },
  { tradeId: 21, from: "Bobby", to: "Manny", picks: ["7.4", "11.3"], date: "August 21, 2025" },
  { tradeId: 22, from: "Manny", to: "Todd", picks: ["2.5", "8.5"], date: "August 21, 2025" },
  { tradeId: 22, from: "Todd", to: "Manny", picks: ["2.2", "9.11"], date: "August 21, 2025" },
  { tradeId: 23, from: "Filter", to: "Terry", picks: ["9.7", "13.7"], date: "August 23, 2025" },
  { tradeId: 23, from: "Terry", to: "Filter", picks: ["10.9", "10.12"], date: "August 23, 2025" },
];

// ----- Helpers: pick formatting -----
export function toPaddedPick(pick) {
  if (!pick) return pick;
  const [r, p] = String(pick).split(".");
  const round = parseInt(r, 10);
  const pos = parseInt(p, 10);
  if (Number.isNaN(round) || Number.isNaN(pos)) return pick;
  return `${round}.${String(pos).padStart(2, "0")}`;
}

export function toUnpaddedPick(pick) {
  if (!pick) return pick;
  const [r, p] = String(pick).split(".");
  const round = parseInt(r, 10);
  const pos = parseInt(p, 10);
  if (Number.isNaN(round) || Number.isNaN(pos)) return pick;
  return `${round}.${pos}`;
}

export function pickStringToOverall(pick) {
  const [r, p] = String(pick).split(".");
  const round = parseInt(r, 10);
  const pos = parseInt(p, 10);
  if (Number.isNaN(round) || Number.isNaN(pos)) return undefined;
  return (round - 1) * TEAMS_PER_ROUND + pos;
}

// Build base snake draft owner mapping for each pick
function buildBaseOwnerByPick(teamOrder) {
  const ownerByUnpadded = new Map();
  for (let i = 0; i < TOTAL_PICKS; i++) {
    const round = Math.floor(i / TEAMS_PER_ROUND) + 1;
    const pickInRound = (i % TEAMS_PER_ROUND) + 1;
    const teamIndex = round % 2 === 0 ? TEAMS_PER_ROUND - pickInRound : pickInRound - 1;
    ownerByUnpadded.set(`${round}.${pickInRound}`, teamOrder[teamIndex]);
  }
  return ownerByUnpadded;
}

// Compute current picks by team from base order + TRADES
export function computePicksByTeam(teamOrder = TEAM_ORDER, trades = TRADES) {
  // Initialize mapping with base snake order, using padded strings for DraftCalculator compatibility
  const picksByTeam = Object.fromEntries(teamOrder.map((t) => [t, []]));
  const ownerByUnpadded = buildBaseOwnerByPick(teamOrder);

  for (let i = 0; i < TOTAL_PICKS; i++) {
    const round = Math.floor(i / TEAMS_PER_ROUND) + 1;
    const pickInRound = (i % TEAMS_PER_ROUND) + 1;
    const unpadded = `${round}.${pickInRound}`;
    const padded = toPaddedPick(unpadded);
    const owner = ownerByUnpadded.get(unpadded);
    picksByTeam[owner].push(padded);
  }

  // Apply trades on top of base mapping
  for (const tr of trades) {
    for (const p of tr.picks) {
      const padded = toPaddedPick(p);
      // remove from sender
      const fromArr = picksByTeam[tr.from] || [];
      const idx = fromArr.indexOf(padded);
      if (idx !== -1) {
        fromArr.splice(idx, 1);
      }
      // add to receiver
      const toArr = picksByTeam[tr.to] || [];
      toArr.push(padded);
    }
  }

  // Sort picks within each team by overall number
  for (const team of Object.keys(picksByTeam)) {
    picksByTeam[team].sort((a, b) => pickStringToOverall(a) - pickStringToOverall(b));
  }

  return picksByTeam;
}

// Export a ready-to-use mapping for components that want current picks
export const TEAM_PICKS_PADDED = computePicksByTeam(TEAM_ORDER, TRADES);


